module.exports = __webpack_public_path__ + "static/media/stairs.42d3dcd3.svg";